<div style="text-align: center">
  <span class="not">404!</span>
  <br>
  <span class="not-m">Page not found-</span>
</div>
